import React, { Component } from "react";
import PropTypes from "prop-types";
import { BlueBtn, CustomCheckbox } from "components/Controls";
import { Field, reduxForm } from "redux-form";
import { required } from "utils/validations";
import { formValueSelector } from "redux-form";
import { tokenSelector } from "containers/EmbeddableWidget/selectors";
import { ProvidersApi } from "api/providers";
const selector = formValueSelector("snap_contract_form");
import { connect } from "react-redux";
import { finishApplication, setSelectedOffer } from "../../actions";
import { downloadPdf, setHeight } from "../helpers";

import "./styles.scss";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

class SnapContract extends Component {
  state = {
    loading: false,
    submitLoading: false,
    bottomIsReached: false,
    error: null,
  };

  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.scrollRef = React.createRef();
  }

  componentWillUnmount() {
    clearTimeout(this.fitTimer);
  }

  // Snap can ask for documents before the agreement (the Oklahoma addendum).
  // Each one is signed here and replaced by the next; only the last one, the
  // agreement, finishes the application.
  isFinalDocument = () => {
    return this.props.selectedOffer.agreement.final_document !== false;
  };

  renderAgreementCheckbox = ({ input, meta }) => {
    return <CustomCheckbox meta={meta} {...input} />;
  };

  submit = (e) => {
    if (!this.isFinalDocument()) {
      return this.signDocument();
    }

    this.setState({ submitLoading: true });
    this.props.finishApplication();
  };

  signDocument = () => {
    const { selectedOffer, token, setSelectedOffer, change } = this.props;
    const { agreement } = selectedOffer;

    this.setState({ submitLoading: true, error: null });
    return ProvidersApi.snapSignDocument(token, {
      lease_app_id: agreement.lease_app_id,
      request_id: agreement.request_id,
      document: agreement.document,
    })
      .then((response) => {
        setSelectedOffer({ agreement: response.data });
        change("isAgreementChecked", false);
        this.setState({ submitLoading: false, bottomIsReached: false });
        if (this.scrollRef.current) {
          this.scrollRef.current.scrollTop = 0;
        }
      })
      .catch(() => {
        this.setState({
          submitLoading: false,
          error: "We couldn't sign this document. Please try again.",
        });
      });
  };

  downloadPdf = () => {
    downloadPdf(this);
  };

  showSubmit = () => {
    this.setState({ bottomIsReached: true });
  };

  hideSubmit = () => {
    this.setState({ bottomIsReached: false });
  };

  renderBottomSnippet = () => {
    const { isAgreementChecked } = this.props;
    const { bottomIsReached, submitLoading, error } = this.state;
    const isFinal = this.isFinalDocument();
    if (bottomIsReached) {
      return (
        <div>
          <div className="privacy-policy-agreement flex flex__align--center">
            <Field
              name="isAgreementChecked"
              validate={[required]}
              component={this.renderAgreementCheckbox}
            />
            <div className="privacy-policy-agreement__label">
              Click here to agree to these terms
            </div>
          </div>
          {isAgreementChecked && (
            <div>
              {isFinal ? (
                <div className="aggreement_content">
                  By clicking SIGN AGREEMENT, you agree to the terms of this
                  agreement which include important lease-to-own disclosures, ACH
                  or other payment method authorization, jury trial waiver, and an
                  arbitration clause.
                </div>
              ) : (
                <div className="aggreement_content">
                  By clicking SIGN ADDENDUM, you agree to the terms of this
                  addendum. Your agreement will be shown next for you to review
                  and sign.
                </div>
              )}
              {error && <div className="aggreement_error">{error}</div>}
              <BlueBtn
                onClick={this.submit}
                loading={submitLoading}
                disabled={!isAgreementChecked || submitLoading}
              >
                {isFinal ? "SIGN AGREEMENT" : "SIGN ADDENDUM"}
              </BlueBtn>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <div className="privacy-policy-agreement privacy-policy-agreement-note">
            Scroll to Review and Sign
          </div>
        </div>
      );
    }
  };

  handleScroll = (e) => {
    if (e.target.scrollTop >= e.target.scrollHeight - 500) {
      this.setState({ bottomIsReached: true });
    }
  };

  // A short document (an addendum can fit on one screen) never scrolls, so
  // check it once its height is set. A hidden step measures 0 and is skipped.
  handleIframeLoad = (e) => {
    setHeight(e);
    clearTimeout(this.fitTimer);
    this.fitTimer = setTimeout(() => {
      const node = this.scrollRef.current;
      if (!this.props.hidden && node && node.clientHeight > 0 && node.scrollHeight - node.clientHeight <= 1) {
        this.setState({ bottomIsReached: true });
      }
    }, 50);
  };

  render() {
    const { selectedOffer, hidden } = this.props;
    const { document_number, documents_count } = selectedOffer.agreement;

    return (
      <div className="snap_contract_step" style={{display: hidden ? 'none' : 'inherit'}}>
        <SimpleBar
          style={{ maxHeight: 350, width: "100%" }}
          scrollableNodeProps={{ ref: this.scrollRef, onScroll: this.handleScroll }}
        >
          <div id="contract-iframe-wrapper">
            {documents_count > 1 && (
              <div className="document_counter font-center">
                Document {document_number} of {documents_count}
              </div>
            )}
            <h2 className="subtitle font-center">
              {this.isFinalDocument() ? "Terms of agreement." : "Addendum to your agreement."}
            </h2>
            <iframe
              onLoad={this.handleIframeLoad}
              srcDoc={selectedOffer.agreement.contract}
              id="contract-iframe"
              width="100%"
              frameBorder="0"
              border="0"
            ></iframe>
          </div>
        </SimpleBar>
        {this.renderBottomSnippet()}
      </div>
    );
  }
}

SnapContract.propTypes = {
  contract: PropTypes.string,
};

SnapContract.defaultProps = {
  contract: "",
};

const mapStateToProps = (state) => ({
  isAgreementChecked: selector(state, "isAgreementChecked"),
  token: tokenSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    finishApplication: (data) => dispatch(finishApplication(data)),
    setSelectedOffer: (value) => dispatch(setSelectedOffer(value)),
  };
};

SnapContract = connect(mapStateToProps, mapDistpatchToProps)(SnapContract);
SnapContract = reduxForm({
  form: "snap_contract_form",
  initialValues: { isAgreementChecked: false },
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(SnapContract);

export default SnapContract;
